import { Icon, IconProps } from '@chakra-ui/react'

export function PayByWireIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 19 20" fill="none" {...props}>
      <path
        d="M4.5 9H2.5V16H4.5V9ZM10.5 9H8.5V16H10.5V9ZM19 18H0V20H19V18ZM16.5 9H14.5V16H16.5V9ZM9.5 2.26L14.71 5H4.29L9.5 2.26ZM9.5 0L0 5V7H19V5L9.5 0Z"
        fill="currentColor"
      />
    </Icon>
  )
}
